import { gql } from "@apollo/client";

// Workers
export const CREATE_WORKER = gql`
  mutation CreateWorker($vendor_id: Int!, $event_id: Int!, $name: String!, $is_active: Boolean!) {
    insert_workers_one(object: { vendor_id: $vendor_id, event_id: $event_id, name: $name, is_active: $is_active }) {
      id
      is_active
    }
  }
`;

export const UPDATE_WORKER = gql`
  mutation UpdateWorker($id: Int!, $data: workers_set_input!) {
    update_workers_by_pk(pk_columns: { id: $id }, _set: $data) {
      id
    }
  }
`;

// Soft-delete: used when the worker has timeclock entries. Preserves the FK
// for historical payroll reporting while removing them from POS pickers
// (which filter is_active = true).
export const DEACTIVATE_WORKER = gql`
  mutation DeactivateWorker($id: Int!) {
    update_workers_by_pk(pk_columns: { id: $id }, _set: { is_active: false }) {
      id
      is_active
    }
  }
`;

// Hard-delete: only safe to call when the worker has no timeclock entries.
// Removes role assignments first to avoid the FK on worker_role_assignments.
export const DELETE_WORKER = gql`
  mutation DeleteWorker($id: Int!) {
    delete_worker_role_assignments(where: { worker_id: { _eq: $id } }) {
      affected_rows
    }
    delete_workers_by_pk(id: $id) {
      id
    }
  }
`;

// Roles
export const CREATE_ROLE = gql`
  mutation CreateRole($vendor_id: Int!, $name: String!, $is_active: Boolean!) {
    insert_worker_roles_one(object: { vendor_id: $vendor_id, name: $name, is_active: $is_active }) {
      id
      is_active
    }
  }
`;

export const UPDATE_ROLE = gql`
  mutation UpdateRole($id: Int!, $data: worker_roles_set_input!) {
    update_worker_roles_by_pk(pk_columns: { id: $id }, _set: $data) {
      id
    }
  }
`;

// Soft-delete: used when the role is assigned to one or more workers.
// Preserves the assignment history so reports can still show "Worker X had role Y."
export const DEACTIVATE_ROLE = gql`
  mutation DeactivateRole($id: Int!) {
    update_worker_roles_by_pk(pk_columns: { id: $id }, _set: { is_active: false }) {
      id
      is_active
    }
  }
`;

// Hard-delete: only safe to call when the role has no assignments.
export const DELETE_ROLE = gql`
  mutation DeleteRole($id: Int!) {
    delete_worker_roles_by_pk(id: $id) {
      id
    }
  }
`;

// Timeclock entries
export const INSERT_TIMECLOCK_ENTRY = gql`
  mutation InsertTimeclockEntry(
    $worker_id: Int!
    $event_id: Int!
    $clock_in: timestamptz!
    $clock_out: timestamptz
  ) {
    insert_timeclock_entries_one(
      object: {
        worker_id: $worker_id
        event_id: $event_id
        clock_in: $clock_in
        clock_out: $clock_out
      }
    ) {
      id
    }
  }
`;

export const UPDATE_TIMECLOCK_ENTRY = gql`
  mutation UpdateTimeclockEntry($id: Int!, $data: timeclock_entries_set_input!) {
    update_timeclock_entries_by_pk(pk_columns: { id: $id }, _set: $data) {
      id
    }
  }
`;

export const DELETE_TIMECLOCK_ENTRY = gql`
  mutation DeleteTimeclockEntry($id: Int!) {
    delete_timeclock_entries_by_pk(id: $id) {
      id
    }
  }
`;

// Role assignments
export const SET_WORKER_ROLES = gql`
  mutation SetWorkerRoles($workerId: Int!, $objects: [worker_role_assignments_insert_input!]!) {
    delete_worker_role_assignments(where: { worker_id: { _eq: $workerId } }) {
      affected_rows
    }
    insert_worker_role_assignments(objects: $objects) {
      affected_rows
    }
  }
`;

export const UPSERT_TIMECLOCK_SETTINGS = gql`
  mutation UpsertTimeclockSettings($vendor_id: Int!, $require_pin: Boolean!) {
    insert_timeclock_settings_one(
      object: { vendor_id: $vendor_id, require_pin: $require_pin }
      on_conflict: { constraint: timeclock_settings_vendor_id_key, update_columns: [require_pin] }
    ) {
      vendor_id
      require_pin
    }
  }
`;

export const BULK_INSERT_WORKERS = gql`
  mutation BulkInsertWorkers($objects: [workers_insert_input!]!) {
    insert_workers(objects: $objects) {
      affected_rows
      returning {
        id
        name
      }
    }
  }
`;
